<template>
  <v-dialog persistent v-model="showaddrecipient" width="500">
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        Add to channel
      </v-card-title>

      <v-card-text>
        <v-autocomplete
          auto-select-first
          :items="aclswithoutcurrentrecipients"
          item-text="username"
          item-value="username"
          chips
          clear-icon="mdi-close-circle"
          hide-selected
          label="Select Account"
          class="ma-6"
          v-model="selectedAccountToAdd"
        >
          <template v-slot:selection="{ attr, on, item, selected }">
            <v-chip
              v-bind="attr"
              :input-value="selected"
              color="#78909c"
              class="white--text"
              v-on="on"
            >
              <v-icon left>mdi-coin</v-icon>
              <span v-text="item.username"></span>
            </v-chip>
          </template>
        </v-autocomplete>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="seconday" text @click.stop="closedialog()">
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!selectedAccountToAdd"
          text
          @click.prevent="submit()"
        >
          Add
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AddRecipient",
  props: {
    showaddrecipient: Boolean,
    acls: Array,
    currentlySelectedAccount: String,
    channel: Object,
  },
  data() {
    return {
      selectedAccountToAdd: undefined,
    };
  },
  computed: {
    aclswithoutcurrentrecipients: function() {
      const result = this.acls.filter(
        ({ username }) =>
          !this.channel.recipients.some(
            (recipient) => recipient.username == username
          )
      );

      return result;
    },
  },
  methods: {
    async submit() {
      const data = {
        account: this.currentlySelectedAccount,
        recipient: this.selectedAccountToAdd,
        channel_id: this.channel._id,
      };
      // console.log(data);

      const res = await this.$store.dispatch("addRecipient", data);
      if (res.Error) {
        this.$store.dispatch("addNotification", {
          type: "errorMessage",
          message: `${res.Error}`,
        });
      } else {
        this.$store.dispatch("addNotification", {
          type: "success",
          message: `Recipient ${this.selectedAccountToAdd} has been added to channel "${this.channel.conversation_name}"`,
        });
      }
      this.selectedAccountToAdd = undefined;
      this.$emit("refreshconversations");
      this.$emit("closedialog");
    },
    closedialog() {
      this.$emit("closedialog");
    },
  },
};
</script>

<style></style>
